import { Radio } from 'antd';
import React from 'react';
import { stringToBoolean } from 'utils/helpers/string-to-boolean';

import s from './styles.module.scss';

import type { FC } from 'react';
import type { FormikProps } from 'formik';
import type { IOptionProps } from './types';

interface UncheckableRadioItemProps {
  name: string;
  value: string;
  formik: FormikProps<any>;
  options: IOptionProps[];
  type?: 'radio' | 'radio-line';
  disabled?: boolean;
  onSelect?: (v: boolean) => void;
  onDeselect?: (v: any) => void;
}

const UncheckableRadioItem: FC<UncheckableRadioItemProps> = ({
  name,
  value,
  formik,
  options,
  type = 'radio',
  disabled,
  onSelect,
  onDeselect,
}) => {
  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    const isBooleanRadioType = stringToBoolean(
      e.currentTarget.dataset.typeBoolean,
    );
    const isFirstQuestion = name === 'patient';
    const radioValue = e.currentTarget.value || null;
    const conditionValue =
      isBooleanRadioType && radioValue !== null
        ? stringToBoolean(radioValue)
        : radioValue;

    if (formik.values[name] === conditionValue) {
      formik.setFieldValue(name, isFirstQuestion ? undefined : null);
      onDeselect?.(conditionValue);
      return;
    }

    if (isBooleanRadioType) {
      formik.setFieldValue(name, conditionValue);
      onSelect?.(Boolean(conditionValue));
    } else {
      formik.setFieldValue(name, radioValue);
    }
  };

  const radioClassname = type === 'radio' ? s.radio : s['radio-items'];

  return (
    <Radio.Group
      name={name}
      value={value}
      className={radioClassname}
      disabled={disabled}
    >
      {options.map((option, idx) => (
        <Radio
          value={option.value}
          key={option.label + idx + name}
          data-type-boolean={typeof option.value === 'boolean'}
          disabled={disabled}
          onClick={handleClick}
        >
          {option.label}
        </Radio>
      ))}
    </Radio.Group>
  );
};
export default UncheckableRadioItem;
